import { css } from "styled-components";

// thumb 색은 border.default를 불투명도 ramp로 단계화한다(앱 HatScrollbar 원본 스타일과 동일):
// resting 58% → 컨테이너 hover/focus-within 82% → thumb 직접 hover 100%. 토큰 위에 alpha만
// 얹기 위해 color-mix로 표현한다.
const scrollbarBase = css`
  scrollbar-color: color-mix(in srgb, ${({ theme }) => theme.color.border.default} 72%, transparent)
    transparent;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  /* 3px 투명 테두리 + content-box clip → 트랙 안에서 여백을 두고 떠 있는 얇은 thumb 모양. */
  &::-webkit-scrollbar-thumb {
    border: 3px solid transparent;
    border-radius: 999px;
    background-clip: content-box;
    background-color: color-mix(
      in srgb,
      ${({ theme }) => theme.color.border.default} 58%,
      transparent
    );
  }

  /* 컨테이너에 hover/focus가 걸리면 thumb를 한 단계 진하게 — 스크롤 가능함을 알린다. */
  &:hover::-webkit-scrollbar-thumb,
  &:focus-within::-webkit-scrollbar-thumb {
    background-color: color-mix(
      in srgb,
      ${({ theme }) => theme.color.border.default} 82%,
      transparent
    );
  }

  /* thumb를 직접 가리키면 가장 진하게. */
  &::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => theme.color.border.default};
  }

  &::-webkit-scrollbar-corner {
    background: transparent;
  }

  &::-webkit-scrollbar-button:start:decrement,
  &::-webkit-scrollbar-button:end:increment {
    width: 0;
    height: 0;
    background: transparent;
  }

  /* 고대비(forced-colors) 모드: 커스텀 색을 버리고 시스템 색에 위임해 가시성을 보장한다. */
  @media (forced-colors: active) {
    scrollbar-color: auto;

    &::-webkit-scrollbar-thumb {
      background-color: CanvasText;
    }
  }
`;

export const yScrollbarStyles = css`
  overflow-x: hidden;
  overflow-y: auto;

  ${scrollbarBase}
`;

export const xScrollbarStyles = css`
  overflow-x: auto;
  overflow-y: hidden;

  ${scrollbarBase}
`;

export const xyScrollbarStyles = css`
  overflow: auto;

  ${scrollbarBase}
`;
